import React, {useState, useCallback, useEffect, useRef} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {formatErrors, coursePeriods, smiles, roleTechnicalSpecialist, userStatusFired} from "../../../constants";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {SelectModal} from "../../../utils/select/SelectModal";
import {clientsMessageAction} from "../../../actions/clientAction";
import {InputCheckbox} from "../../../utils/checkbox/InputCheckbox";
import {i_attach, i_close, i_smile} from "../../../icons";
import {ChatAddFile} from "../../chat/utils/ChatAdd";
import {TextareaChat} from "../../../utils/textarea/TextareaChat";

export function coursePeriodsWeeks() {
  let res = {}, week = 0;
  coursePeriods.forEach((i, k) => {
    if (!res.hasOwnProperty(k)) {
      res[k] = {};
    }
    const wn = i['days'] / 7;
    for (let wi = 1; wi <= wn; wi++) {
      week += 1;
      res[k][wi] = week;
    }
  });
  return res;
};

export function ClientsMessageModal({curatorId, users, checked, trigger}) {
  const [weeks] = useState(coursePeriodsWeeks());
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    curator_id: curatorId || '',
    client_ids: checked ? Object.keys(checked) : [],
    program_stages: {},
    program_stages_weeks: {},
    file: null,
    in_archive: false,
    course: 1,
    in_week: false,
    last_message: 0
  });
  const [checkedAll, setCheckedAll] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user.profile);

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
  };

  const handleChangeForm = useCallback((e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value}
    });
  }, []);

  const handleCheckedAll = () => {
    let program_stages = {}, program_stages_weeks = {};
    if (!checkedAll) {
      for (let sk in weeks) {
        program_stages[sk] = true;
        for (let k in weeks[sk]) {
          program_stages_weeks[weeks[sk][k]] = true;
        }
      }
    }
    setCheckedAll(!checkedAll);
    setForm((form) => {
      return {...form, program_stages, program_stages_weeks}
    });
  };

  const handleChecked = (value) => {
    let values = {...form.program_stages};
    let program_stages_weeks = {...form.program_stages_weeks};
    if (values.hasOwnProperty(value) && values[value]) {
      delete values[value];
      for (let k in weeks[value]) {
        if (program_stages_weeks.hasOwnProperty(weeks[value][k]) && program_stages_weeks[weeks[value][k]]) {
          delete program_stages_weeks[weeks[value][k]];
        }
      }
      setForm((form) => {
        return {...form, program_stages: values, program_stages_weeks}
      });
      setCheckedAll(false);
    } else {
      values[value] = true;
      for (let k in weeks[value]) {
        program_stages_weeks[weeks[value][k]] = true;
      }
      setForm((form) => {
        return {...form, program_stages: values, program_stages_weeks}
      });
    }
  };

  const handleCheckedWeek = (stage, value) => {
    let program_stages = {...form.program_stages};
    let program_stages_weeks = {...form.program_stages_weeks};
    if (program_stages_weeks.hasOwnProperty(value) && program_stages_weeks[value]) {
      delete program_stages_weeks[value];
      let empty = true;
      for (let k in weeks[stage]) {
        if (program_stages_weeks[weeks[stage][k]]) {
          empty = false;
          break;
        }
      }
      if (empty) {
        delete program_stages[stage];
      }
      setForm((form) => {
        return {...form, program_stages, program_stages_weeks}
      });
      setCheckedAll(false);
    } else {
      program_stages_weeks[value] = true;
      setForm((form) => {
        return {...form, program_stages_weeks}
      });
    }
  };

  const handleSmile = (e) => {
    insertToMessage(e.target.value);
  };

  const insertToMessage = (value) => {
    if (inputRef.current.value.length + value.length > 4096) {
      return;
    }
    const current = inputRef.current.value;
    const position = inputRef.current.selectionStart;
    inputRef.current.value = current.substring(0, position) +
      value +
      current.substring(position, current.length);
    inputRef.current.focus();
    inputRef.current.setSelectionRange(position + value.length, position + value.length);
  };

  const setFile = (file) => {
    setForm((form) => {
      return {...form, file}
    });
  };

  const handleSubmit = () => {
    if (loading) {
      return false;
    }
    let errs = {};
    const values = {...form};
    values.program_stages = Object.keys(values.program_stages);
    values.program_stages_weeks = Object.keys(values.program_stages_weeks);
    values.message = inputRef.current.value.trim();
    if (!values.message && !values.file) {
      errs.message = true;
    }
    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }
    setLoading(true);

    dispatch(clientsMessageAction(values)).then(() => {
      setLoading(false);
      setFile(null);
      inputRef.current.value = '';
      setOpen(false);
      toast.success('Сообщение успешно создано!', {position: toast.POSITION.BOTTOM_RIGHT});
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const handleCheckedInArchive = () => {
      let in_archive = form.in_archive;
      in_archive = !in_archive
    setForm((form) => {
      return {...form, in_archive}
    });
  };
  
  const handleCheckedInWeek = () => {
      let in_week = form.in_week;
      in_week = !in_week
    setForm((form) => {
      return {...form, in_week}
    });
  };

  useEffect(() => {
    if (open) {
      setForm({
        curator_id: curatorId || '',
        client_ids: checked ? Object.keys(checked) : [],
        program_stages: {},
        program_stages_weeks: {},
        file: null,
        in_archive: false,
        course: 1,
        in_week: false,
        last_message: 0
      });
      setErrors({});
      setCheckedAll(false);
    }
  }, [open, checked, curatorId]);

  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={false}>
    <React.Fragment>
      <div className="modal__title">Массовая рассылка</div>
      <div className="modal__scroll">
        {user && user.role_id === roleTechnicalSpecialist && <div className="modal__inner modal__inner--left">
            <InputCheckbox name="in_archive" title="В архиве" checked={form.in_archive} onChange={() => handleCheckedInArchive()}/>
        </div>}
        
        <div className="modal__inner modal__inner--left">
            <InputCheckbox name="in_week" title="Всем на программе week" checked={form.in_week} onChange={() => handleCheckedInWeek()}/>
        </div>
        
        {!form.in_archive && form.client_ids.length > 0 && <p className="modal__subtitle">Выбрано пользователей: <span>{form.client_ids.length}</span></p>}
        {!form.in_archive && form.client_ids.length === 0 && !curatorId && <div className="modal__inner">
          <SelectModal title="Всем пользователям куратора"
                                                      name="curator_id"
                                                      value={form.curator_id}
                                                      error={errors.curator_id}
                                                      disabled={loading}
                                                      onChange={handleChangeForm}>
            <option value="">Все</option>
            {
              users && users.map(i => i.value && (i.role_id !== roleTechnicalSpecialist) && (i.status !== userStatusFired) && <option key={i.value} value={i.value}>{i.text}</option>)
            }
          </SelectModal>
        </div>}
        {!form.in_archive && !form.in_week && <div className="modal__inner modal__inner--left">
          <div className="modal__group">
            <p className="modal__help">Ступень программы</p>
            <InputCheckbox name="checkedAll" title="Всем" checked={checkedAll}
                           onChange={() => handleCheckedAll()}/>
            {coursePeriods.map((i, k) => {
                return <React.Fragment key={k}>
                  <InputCheckbox name={k} title={i.title} checked={form.program_stages[k] || false}
                               onChange={() => handleChecked(k)}/>
                  {form.program_stages[k] && i.days / 7 > 1 && <div className="square-checkbox__sub">
                    <InputCheckbox name={k + '_1'} title="1-я неделя" checked={form.program_stages_weeks[weeks[k][1]] || false}
                                   onChange={() => handleCheckedWeek(k, weeks[k][1])}/>
                    <InputCheckbox name={k + '_2'} title="2-я неделя" checked={form.program_stages_weeks[weeks[k][2]] || false}
                                   onChange={() => handleCheckedWeek(k, weeks[k][2])}/>
                    {i.days / 7 > 2 && <InputCheckbox name={k + '_3'} title="3-я неделя" checked={form.program_stages_weeks[weeks[k][3]] || false}
                                                      onChange={() => handleCheckedWeek(k, weeks[k][3])}/>}
                    {i.days / 7 > 3 && <InputCheckbox name={k + '_4'} title="4-я неделя" checked={form.program_stages_weeks[weeks[k][4]] || false}
                                                      onChange={() => handleCheckedWeek(k, weeks[k][4])}/>}
                  </div>}
                </React.Fragment>
              }
            )}
          </div>
        </div>}
        
        {form.in_archive && <div className="modal__inner modal__inner--left">
          <SelectModal title="Всем пользователям куратора"
                                                      name="course"
                                                      value={form.course}
                                                      error={errors.course}
                                                      disabled={loading}
                                                      onChange={handleChangeForm}>
            <option value="1">Полная программа</option>
            <option value="2">Рассрочка</option>
            <option value="3">Без купленных курсов</option>
            <option value="4">Все</option>
            <option value="5">Неделя</option>
          </SelectModal>
        </div>}

        {!form.in_archive && <div className="modal__inner modal__inner--left">
          <SelectModal title="Последнее сообщение"
                       name="last_message"
                       value={form.last_message}
                       error={errors.last_message}
                       disabled={loading}
                       onChange={handleChangeForm}>
            <option value={0}>Последнее сообщение</option>
            <option value={3}>3 дня</option>
            <option value={4}>4 дня</option>
            <option value={5}>5 дней</option>
          </SelectModal>
        </div>}

        <div className="chat-panel__inner">
          <ChatAddFile handleChange={setFile} loading={loading}/>
          <TextareaChat inputRef={inputRef} loading={loading} placeholder="Написать..." minHeight={104} handleSubmit={handleSubmit}/>
          <button type="button" className="chat-panel__icon">
            {i_smile()}
            <ul className="dropdown dropdown--top dropdown--flex">
              {smiles.map((i, k) => <li key={k} className="dropdown__item">
                <input type="button" value={i} className="dropdown__smile" onClick={handleSmile} />
              </li>)}
            </ul>
          </button>
        </div>
        {form.file !== null && <div className="chat-panel__attached">
          <div className="attached--item"><span className="attached--icon">{i_attach()}</span> {form.file.name} <span className="attached--close" onClick={() => setFile(null)}>{i_close()}</span></div>
        </div>}
        <div className="template">
          <button type="button" className="template__item" onClick={() => insertToMessage('{real_name}')}>real_name</button>
          <button type="button" className="template__item" onClick={() => insertToMessage('{control}')}>control</button>
        </div>
      </div>
      <div className="modal__btns">
        <button type="button" className="modal__btn btn" onClick={handleSubmit} disabled={loading}>Отправить</button>
      </div>
    </React.Fragment>
  </Modal>
};
